var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4444 35.5556C44.4444 36.7343 43.9762 37.8648 43.1427 38.6983C42.3092 39.5317 41.1787 40 40 40H4.44444C3.2657 40 2.13524 39.5317 1.30175 38.6983C0.468252 37.8648 0 36.7343 0 35.5556V4.44444C0 3.2657 0.468252 2.13524 1.30175 1.30175C2.13524 0.468252 3.2657 0 4.44444 0H15.5556L20 6.66667H40C41.1787 6.66667 42.3092 7.13492 43.1427 7.96841C43.9762 8.80191 44.4444 9.93237 44.4444 11.1111V35.5556Z",
    fill: "#12A500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2227 17.7778V31.1111",
    stroke: "#050520",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5557 24.4445H28.889",
    stroke: "#050520",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDark);
export default __webpack_public_path__ + "static/media/folder-dark.0f4b58fd4f227ed553d7bf9209fc4b78.svg";
export { ForwardRef as ReactComponent };